import { useMemo } from 'react';
import { useSelector } from 'react-redux';
export const getExperimentTreatments = state => {
  const defaultResult = {
    hasFetched: false,
    isFetching: false,
    treatments: {}
  };
  return state.experiments || defaultResult;
};
export const useExperimentTreatments = () => {
  const {
    hasFetched,
    isFetching,
    treatments
  } = useSelector(getExperimentTreatments);
  return useMemo(() => {
    if (!hasFetched || isFetching) {
      return undefined;
    }
    return treatments;
  }, [hasFetched, isFetching, treatments]);
};